export default __webpack_public_path__ + "static/media/a_wdt_c_1.6f0cdbe7.mp3";